import { Box } from "@/components/core-components";
import { Modal } from "@flash-tecnologia/flamingo-ui-modal";
import { LinearProgress } from "@mui/material";

interface GenerateContractLoadingModalProps {
  open: boolean;
  onClose: () => void;
}

export const GenerateContractLoadingModal = ({
  open,
  onClose,
}: GenerateContractLoadingModalProps) => {
  return (
    <Modal.Root open={open} onOpenChange={() => open && onClose()} size="small">
      <Modal.Content.Root hideClose disableCloseOnOverlayClick>
        <Modal.Content.Highlight
          size="compact"
          type="announcement"
          customIconName="IconLoader"
        >
          Carregando ...
        </Modal.Content.Highlight>
        <Modal.Content.Title>
          Estamos gerando o seu contrato
        </Modal.Content.Title>
        <Modal.Content.Description>
          Aguarde alguns instantes...
        </Modal.Content.Description>
        <Box $mb="s" flexDirection="column">
          <LinearProgress variant="indeterminate" />
        </Box>
      </Modal.Content.Root>
    </Modal.Root>
  );
};
